import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Divider, MenuList } from '@mui/material';
import { flow } from 'fp-ts/function';
import { useRef } from 'react';
import { AccountMenuLinks } from './account-menu-links';
import ProfileLink from './profile-link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PureAccountMenu = function PureAccountMenu(_ref) {
  var ref = _ref.ref,
      profile = _ref.profile,
      isDesktop = _ref.isDesktop,
      profileRef = _ref.profileRef,
      handlePopoverClose = _ref.handlePopoverClose,
      privacyPolicyLink = _ref.privacyPolicyLink,
      termsAndConditionsLink = _ref.termsAndConditionsLink,
      memberMessagingEnabled = _ref.memberMessagingEnabled,
      actionBarLangSelectorEnabled = _ref.actionBarLangSelectorEnabled;
  return /*#__PURE__*/_jsxs(MenuList, {
    sx: {
      width: 'auto',
      maxWidth: 341,
      height: 'auto'
    },
    id: "customized-menu",
    "data-element": "MenuList",
    "data-component": "PureAccountMenu",
    "data-source-file": "account-menu.tsx",
    children: [/*#__PURE__*/_jsx(ProfileLink, {
      ref: profileRef,
      profile: profile,
      isDesktop: isDesktop,
      onClick: handlePopoverClose,
      "data-element": "ProfileLink",
      "data-component": "PureAccountMenu",
      "data-source-file": "account-menu.tsx"
    }), /*#__PURE__*/_jsx(Divider, {
      "data-element": "Divider",
      "data-source-file": "account-menu.tsx"
    }), /*#__PURE__*/_jsx(Box, {
      ref: ref,
      sx: {
        position: 'relative',
        overflowX: 'hidden'
      },
      "data-element": "Box",
      "data-source-file": "account-menu.tsx",
      children: /*#__PURE__*/_jsx(AccountMenuLinks, {
        handlePopoverClose: handlePopoverClose,
        privacyPolicyLink: privacyPolicyLink,
        termsAndConditionsLink: termsAndConditionsLink,
        memberMessagingEnabled: memberMessagingEnabled,
        actionBarLangSelectorEnabled: actionBarLangSelectorEnabled,
        "data-element": "AccountMenuLinks",
        "data-source-file": "account-menu.tsx"
      })
    })]
  });
};

var useProps = function useProps(props) {
  return _objectSpread({
    ref: useRef(null),
    profileRef: useRef(null)
  }, props);
};

export default Object.assign(flow(useProps, PureAccountMenu), {
  displayName: 'AccountMenu'
});